import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { applicationStore } from "../../../stores/ApplicationStore";
import { THEME } from "../../../theme/ThemeStore";
import { ApplicationValues } from "../../../types/models";
import { pushRoute } from "../../app/router/history";
import { useMobileMediaQuery } from "../../hooks/useMobileMediaQuery";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { TopImage } from "../../ui/TopImage";
import { PersonalDataForm } from "../PersonalDataForm";
import { ApplicationRoutes } from "../router/ApplicationRoutes";

export const PersonalDataSite = observer(() => {
    const isMobile = useMobileMediaQuery();
    const isDal = THEME.THEME_NAME === "dal";

    const handleSubmit = (application: ApplicationValues) => {
        applicationStore.currentApplication = application;
        applicationStore.isStepFinished["personalData"] = true;
        pushRoute(ApplicationRoutes.DETAILS);
    };

    return (
        <>
            <TopImage imageUrl={THEME.Images.headerImage01} />
            <ContentWrapper>
                <div style={{ marginBottom: isMobile ? 23 : 36 }}>
                    <h3 style={{ marginBottom: isDal ? 12 : undefined }}>{t("screen.personalData.title")}</h3>
                    {isDal && <p className="applicationCaption">{t("screen.personalData.caption")}</p>}
                </div>
                <PersonalDataForm onSubmit={handleSubmit} />
            </ContentWrapper>
        </>
    );
});
